import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { PrimaryButton } from "../../../../global/buttons/material/primaryButton/PrimaryButton";
import { setRegisterModal } from "../../../../../redux/pages/registerPageSlice";

export const ListingModalLoginOpenSignupModalBtn = () => {
  const isLoadingListingModal = useSelector(
    (state: RootState) => state.trainingPlan.loadingLoginListingModal
  );
  const dispatch = useDispatch();

  return (
    <PrimaryButton
      type="submit"
      title="Create Account"
      onClick={() => {
        dispatch(setRegisterModal());
      }}
      disabled={isLoadingListingModal}
    />
  );
};
